'use strict'

import $ from 'jquery'

export default function () {
    $('.nav-main-l1__link').on('click', function (e) {
        if ( $(this).hasClass('menu-item-has-children') ) {
            e.preventDefault()
            e.stopPropagation()


            const $l2 = $(this).parent().find('.nav-main-l2')
            if ( $l2.hasClass('is-active') ) {
                $('.nav-main-l1__link, .nav-main-l2').removeClass('is-active')
            } else {
                $('.nav-main-l1__link, .nav-main-l2').removeClass('is-active')
                $(this).addClass('is-active')
                $l2.addClass('is-active')
            }
        } else {
            $('.nav-main-l1__link, .nav-main-l2').removeClass('is-active')
        }
    })

    $('.nav-main-l2').on('click', function (e) {
        e.stopPropagation()
    })

    $('body, .nav-main-l2__back').on('click', function () {
        $('.nav-main-l1__link, .nav-main-l2').removeClass('is-active')
    })

    // Mobile
    $('#mobileOpen').on('click', function () {
        $('#mobileMenu').addClass('is-active')
    })

    $('#mobileClose').on('click', function () {
        $('#mobileMenu').removeClass('is-active')
    })
}
